import { s_home } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import FaqList from './FaqList'

type FaqSectionProps = {
  bgColor: string
}

const FaqSection: React.FC<FaqSectionProps> = ({ bgColor }) => {
  const { t } = useTranslation()
  return (
    <div className="flex w-full items-center justify-center pt-[174px] pb-[100px]" style={{ background: bgColor }}>
      <div className="flex max-w-[1080px] flex-col items-center justify-center px-[20px]">
        <h2 className="text-36 text-center font-bold leading-[140%] text-[#000000]">{t(s_home.faq.title.desktop)}</h2>

        <div className="mt-16 max-w-[600px]">
          <FaqList />
        </div>
      </div>
    </div>
  )
}

export default FaqSection
